module.exports = ".form-check-label{\r\n    color: var(--color);\r\n    text-shadow: 2px 1px #222;\r\n}"